import React, { useState, useEffect, useContext } from "react";
import AuthContext from "../../Context/AuthContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList, faPlus } from "@fortawesome/free-solid-svg-icons";
import Dropdown from "react-bootstrap/Dropdown";
import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import OrganizationsList from "../Components/OrganizationsList";
import Spinner from "react-bootstrap/Spinner";
import axios from "axios";
import { useTranslation } from "react-i18next";
import "./Organizations.css";

function Organizations() {
  const [isLoading, setIsLoading] = useState(true);
  const [organizations, setOrganizations] = useState([]);

  const { state } = useContext(AuthContext);

  const { t } = useTranslation();

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/organizations/account/${state.account}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setOrganizations(response.data.organizations);
      setIsLoading(false);
    }
    fetch();
  }, []);

  if (isLoading === true) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Container fluid>
        <Row className="align-items-center">
          <Col lg={11} className="organizations-header">
            <h2>{t("Organizaciones.Titulo")}</h2>
          </Col>
          <Col lg={1} className="right organizations-content">
            <Dropdown>
              <Dropdown.Toggle id="dropdown-basic">
                <FontAwesomeIcon icon={faList} />
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item as={Link} to={`/organizations/new`}>
                  <FontAwesomeIcon icon={faPlus} />{" "}
                  {t("Organizaciones.NuevaOrganizacion")}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Col>
        </Row>
        <Row>
          {organizations.length === 0 ? (
            <Col className="empty-organizations center">
              <h5>{t("Organizaciones.SinOrganizaciones")}</h5>
            </Col>
          ) : (
            <OrganizationsList organizations={organizations} />
          )}
        </Row>
      </Container>
    );
  }
}

export default Organizations;
